








































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AppVue from "@/AppVue.vue";

import { InputSelectCpt, InputDateCpt, InputFieldCpt, InputSearchFieldCpt, InputDateRangeCpt } from "@/core/components";
import { DashboardFilterModel, DashboardLookups, DateRangeModel, GridModel, GridFilter } from "@/core/models";

import { CompanyService } from "@/core/services";

@Component({
  components: {
    InputSelectCpt,
    InputDateCpt,
    InputFieldCpt,
    InputSearchFieldCpt,
    InputDateRangeCpt,
  },
})
export default class DashboardGridFiltersCpt extends AppVue {
  @Prop() filter: DashboardFilterModel;
  @Prop() grid: GridModel<any, GridFilter>;

  dateRange = {} as DateRangeModel;

  lookups = {} as DashboardLookups;
  loading = false;

  async created() {
    await this.initializeLookups();
    this.initializeDateRangeFilter();
  }

  private dateRangeChanged() {
    if (!this.dateRange || !this.dateRange.dateRange || this.dateRange.dateRange.length <= 1) {
      this.filter.startDate = "" as any;
      this.filter.endDate = "" as any;
    } else {
      this.filter.startDate = this.dateRange.dateRange[0];
      this.filter.endDate = this.dateRange.dateRange[1];
    }
    this.changed();
  }

  private changed() {
    this.$emit("filter-changed", this.filter);
  }
  private initializeDateRangeFilter() {
    this.dateRange = {
      dateRange: [this.filter.startDate, this.filter.endDate],
    };
  }

  private async initializeLookups() {
    this.loading = true;
    try {
      this.lookups = await CompanyService.getDashboardLookups();
      this.lookups.regions.unshift({
        id: 0,
        text: "All",
      });
      this.lookups.workshopStatus.unshift({
        id: 0,
        text: "All",
      });
      this.lookups.counties.unshift({
        id: 0,
        text: "All",
      });
      this.lookups.sectors.unshift({
        id: 0,
        text: "All",
      });
    } finally {
      this.loading = false;
    }
  }
}
